<script>
import moment from 'moment';

export default {
  name: 'VideoRectangleTile',
  props: {
    videoId: {
      type: String,
      required: true,
    },
    videoTitle: {
      type: String,
      required: true,
    },
    videoImageUrl: {
      type: String,
      required: true,
    },
    videoDuration: {
      type: String,
      required: true,
    },
    videoPublishedAt: {
      type: String,
      required: true,
    },
  },
  computed: {
    timeFromPublish() {
      moment.updateLocale('en', {
        relativeTime: {
          future: 'in %s',
          past: '%s ago',
          s: '1s',
          ss: '%ss',
          m: '1m',
          mm: '%dm',
          h: '1h',
          hh: '%dh',
          d: '1d',
          dd: '%dd',
          M: '1 month',
          MM: '%dM',
          y: '1 year',
          yy: '%dY',
        },
      });
      return moment
        .utc(this.videoPublishedAt)
        .local()
        .fromNow(true);
    },
  },
};
</script>

<template>
  <div class="vid-rectangle-tile__container">
    <div v-lazy:background-image="videoImageUrl" class="vid-rectangle-tile__image">
      <div class="vid-rectangle-tile__play-container">
        <div class="vid-rectangle-tile__play-button"></div>
        <div class="vid-rectangle-tile__duration">
          <p>{{ videoDuration }}</p>
        </div>
      </div>
      <h3 class="vid-rectangle-tile__title">{{ videoTitle }}</h3>
      <h4 class="vid-rectangle-tile__published">{{ timeFromPublish }}</h4>
    </div>
  </div>
</template>
